export default __webpack_public_path__ + "static/media/vegetables.75703f2e.jpg";